import styled from 'styled-components';

export const AiSearchContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.tokens.BaseSpace50};
`;

export const LabelWithIcon = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.tokens.BaseSpace30};
    margin-bottom: ${({ theme }) => theme.tokens.BaseSpace40};
    font-size: 20px;

    strong {
        font-size: 20px;
    }
`;

export const AiSearchContent = styled.div`
    width: 100%;
`;

export const InputSection = styled.div`
    margin-bottom: ${({ theme }) => theme.tokens.BaseSpace50};
`;

export const InputDescription = styled.p`
    font-size: 14px;
    color: #666;
    margin-bottom: ${({ theme }) => theme.tokens.BaseSpace40};
`;
